/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DynamicApplicationDto } from '../../models/dynamic-application-dto';

export interface DynamicApplicationsIdGet$Params {
  id: number;
}

export function dynamicApplicationsIdGet(
  http: HttpClient,
  rootUrl: string,
  params: DynamicApplicationsIdGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<DynamicApplicationDto>> {
  const rb = new RequestBuilder(rootUrl, dynamicApplicationsIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DynamicApplicationDto>;
    }),
  );
}

dynamicApplicationsIdGet.PATH = '/dynamic/applications/{id}';
